module.exports = {
  localeName: 'nl-NL',
  momentFormat: 'DD-MM-YYYY',
  qrCodeUrl: 'https://www.inmoment.com/websurvey/2/begin?gateway=NikeWEQRCode&base32=surveyCode&SurveyType=2&countryCode=528&loyaltyMember=1&PrintEreceipt=1&weqrcode=7',
  taxId: 'Btw store: ',
};
